import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'kk',
    fallbackLng: 'ru',
    supportedLngs: ['kk', 'ru', 'en'],
    debug: false,
    detection: {
      order: ['cookie', 'navigator'],
      cache: ['cookie'],
      cookieName: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    }
  })
  .then(() => {
    console.info('[i18n] Initialized, language:', i18n.language)
  })

export default i18n
